var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.event
        ? _c("span", [_vm._v(_vm._s(_vm.placeholder))])
        : _c("icon-label", {
            attrs: {
              icon: _vm.event.icon,
              bkgColor: _vm.event.classShort,
              value: _vm.event.label
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }